import QRCode from 'qrcode'

const QR_SIZE = 1024
const BASE_OPTIONS = {
  margin: 2,
  width: QR_SIZE,
  color: {
    dark: '#000000'
  }
}

const dataUrlToUint8Array = (dataUrl) => {
  const base64Content = dataUrl.split(',')[1] || ''
  const binaryString = atob(base64Content)
  const bytes = new Uint8Array(binaryString.length)

  for (let index = 0; index < binaryString.length; index += 1) {
    bytes[index] = binaryString.charCodeAt(index)
  }

  return bytes
}

const dataUrlToBlob = (dataUrl) => {
  const byteArray = dataUrlToUint8Array(dataUrl)
  const mimeType = dataUrl.substring(dataUrl.indexOf(':') + 1, dataUrl.indexOf(';'))
  return new Blob([byteArray], {type: mimeType})
}

const stringToUint8Array = (content) => {
  const utf8Content = unescape(encodeURIComponent(content))
  const bytes = new Uint8Array(utf8Content.length)

  for (let index = 0; index < utf8Content.length; index += 1) {
    bytes[index] = utf8Content.charCodeAt(index)
  }

  return bytes
}

export const sanitizeSmartLink = (smartLink) => {
  if (typeof smartLink !== 'string') {
    return ''
  }

  return smartLink.trim()
}

export const hasSmartLink = (smartLink) => sanitizeSmartLink(smartLink).length > 0

export const createQrSvg = async (smartLink) => QRCode.toString(sanitizeSmartLink(smartLink), {
  ...BASE_OPTIONS,
  type: 'svg',
  color: {
    ...BASE_OPTIONS.color,
    light: '#0000'
  }
})

export const createQrPngDataUrl = async (smartLink) => QRCode.toDataURL(sanitizeSmartLink(smartLink), {
  ...BASE_OPTIONS,
  type: 'image/png',
  color: {
    ...BASE_OPTIONS.color,
    light: '#0000'
  }
})

export const createQrJpgDataUrl = async (smartLink) => {
  const pngDataUrl = await createQrPngDataUrl(smartLink)
  const image = new Image()

  await new Promise((resolve, reject) => {
    image.onload = resolve
    image.onerror = reject
    image.src = pngDataUrl
  })

  const canvas = document.createElement('canvas')
  canvas.width = image.width
  canvas.height = image.height
  const context = canvas.getContext('2d')

  context.fillStyle = '#FFFFFF'
  context.fillRect(0, 0, canvas.width, canvas.height)
  context.drawImage(image, 0, 0)

  return canvas.toDataURL('image/jpeg', 0.95)
}

export const createQrExportPayload = async (smartLink) => {
  const normalizedSmartLink = sanitizeSmartLink(smartLink)

  if (!normalizedSmartLink) {
    throw new Error('SmartLink is empty')
  }

  const [svg, pngDataUrl, jpgDataUrl] = await Promise.all([
    createQrSvg(normalizedSmartLink),
    createQrPngDataUrl(normalizedSmartLink),
    createQrJpgDataUrl(normalizedSmartLink)
  ])

  return {
    svg,
    svgBytes: stringToUint8Array(svg),
    pngDataUrl,
    jpgDataUrl,
    pngBlob: dataUrlToBlob(pngDataUrl),
    jpgBlob: dataUrlToBlob(jpgDataUrl),
    pngBytes: dataUrlToUint8Array(pngDataUrl),
    jpgBytes: dataUrlToUint8Array(jpgDataUrl)
  }
}
